// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"bc2d7bf6","99":"dad9ce6f","220":"892fd611","345":"33a70d80","378":"984511b8","461":"bc77fe6d","470":"372b9548","514":"64e04216","602":"2d3d909e","770":"899d1769","790":"be9d12e2","842":"34972399","918":"a5decfcb","980":"d23a2c2a"}[chunkId] + ".chunk.css";
};